
function sendData(params) {
  if (Shopify) {
    Shopify.analytics.publish("member-datac", {
      ...params,
      customerId: window.customer_id || "",
      platform: window.innerWidth > 768 ? "pc" : "mobile",
    });
  } else {
    window.report_faro({
      file_name: 'assets/member-login-register.js',
      func_name: 'sendData',
      desc: 'Unable to publish member analytics',
      error: 'Shopify analytics is unavailable'
    });
  }
}

function memberLoginRegisterInit() {
  if (window.is_member_login_js_inited) return;
  window.is_member_login_js_inited = true;

  try {
    const domain = "https://aws-mall.ogl-dragon.com";
    const isMobile = window.innerWidth < 768
    const isLogin = window.member_is_login;

    let urlParams = new URLSearchParams(window.location.search);

    const rf = urlParams.get("rf");
    const utm_source = urlParams.get("utm_source");
    const curPath = location.pathname.split("/").filter(Boolean).pop() == 'register' ? 'register' : 'login'
    const visitType =
      curPath || "login";
    let targetTab;

    // 保存 rf 和 utm_source
    if (rf) localStorage.setItem("member-rf", rf);
    if (utm_source) localStorage.setItem("member-utm_source", utm_source);

    function handleRecoverShow(e) {
      e.preventDefault();
      const curWrapperBox = $(e.target).closest(".login-or-register");
      $(curWrapperBox).find('.t4s-tab-item').removeClass('active');
      $(curWrapperBox).find('.t4s-tab-content .t4s-tab-panel').removeClass('active');
      const login_tab_item = $(curWrapperBox).find('.t4s-tab-item[data-target="login"]');
      const login_tab_content = $(curWrapperBox).find('.t4s-tab-content #tab-login');
      const recoverForm = $(curWrapperBox).find("#recover");
      const loginForm = $(curWrapperBox).find("#login");
      //展示出login
      login_tab_content.addClass('active');
      login_tab_item.addClass('active');
      if (this.getAttribute("href") === "#login") {
        // 回到登录页面
        recoverForm.css('display', "none");
        loginForm.css('display', "block");
      } else {
        // 前往找回密码页面
        recoverForm.css('display', "block");
        loginForm.css('display', "none");
        // 发送重置密码的埋点
        sendData({ name: `member-reset-password` });
      }
    }
    // ajax表单请求-------------
    async function loginAjax(customer_info) {
      const formData = new FormData();
      formData.append("form_type", "customer_login");
      formData.append("utf8", '✓');
      formData.append("customer[email]", customer_info.email);
      formData.append("customer[password]", customer_info.password);
      formData.append("return_url", `/account/login`);
      $('#member-login-modal #login-error').hide()
      try {
        const login_res_html = await fetch(`/account/login`, {
          method: "POST",
          body: formData,
          headers: {
            'cache-control': 'max-age=0'
          }
        }).then((res) => res.text())

        const parser = new DOMParser();
        const doc = parser.parseFromString(login_res_html, 'text/html');
        const info = doc.querySelector(
          '#customer-info'
        );
        const customerInfo = info?.innerText?.trim() || '{}'
        const infoObj = JSON.parse(customerInfo)

        if (!infoObj.id) {
          $('#member-login-modal #login-error').show()
          sendData({
            name: `member-login-failed`,
            message: 'Incorrect email or password.',
            type: 'cart-modal'
          });
        } else {
          document.querySelector('#member-login-modal .t4s-drawer__close')?.click()
          // 移除所有drawer
          $('a[href="/account"]').removeAttr('data-drawer-options')
          await T4SThemeSP.Cart.getToFetch()
          window.customer = infoObj
          window.customer_id = infoObj.id
          const loginEvent = new CustomEvent('logined');
          document.dispatchEvent(loginEvent)
          sendData({
            name: `member-login-success`,
            type: 'cart-modal'
          });
        }
      } catch (err) {
        sendData({
          name: `member-login-failed`,
          message: err.message,
          type: 'cart-modal'
        });
      }
    }

    function htmlDecodeByRegex(text) {
      return text
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
      // 可以根据需要添加更多转义规则
    }

    async function registerAjax(customer_info) {
      const formData = new FormData();
      formData.append("form_type", "create_customer");
      formData.append("utf8", '✓');
      formData.append("customer[first_name]", customer_info.first_name);
      formData.append("customer[last_name]", customer_info.last_name);
      formData.append("customer[email]", customer_info.email);
      formData.append("customer[password]", customer_info.password);
      formData.append("marketing", customer_info.marketing);
      formData.append("return_url", `/account/login`);
      $('#member-login-modal #register-error').hide()
      try {
        const register_res_html = await fetch(`/account`, {
          method: "POST",
          body: formData,
          headers: {
            'cache-control': 'max-age=0'
          }
        }).then((res) => res.text())

        const parser = new DOMParser();
        const doc = parser.parseFromString(register_res_html, 'text/html');
        const info = doc.querySelector(
          '#customer-info'
        );
        const error_info = doc.querySelector(
          '.form-error ul li'
        )
        const customerInfo = info?.innerText?.trim() || '{}'

        const infoObj = JSON.parse(customerInfo)

        if (!infoObj.id) {
          $('#member-login-modal #register-error').html(htmlDecodeByRegex(error_info.innerText))
          $('#member-login-modal #register-error').show()
          $('#member-login-modal #register-error a[href="/account/login#recover"').on('click', handleRecoverShow)
          sendData({
            name: `member-register-failed`,
            message: error_info.innerText,
            type: 'cart-modal'
          });
        } else {
          document.querySelector('#member-login-modal .t4s-drawer__close')?.click()
          // 移除所有drawer
          $('a[href="/account"]').removeAttr('data-drawer-options')
          await T4SThemeSP.Cart.getToFetch()
          window.customer = infoObj
          window.customer_id = infoObj.id
          const loginEvent = new CustomEvent('logined');
          document.dispatchEvent(loginEvent)
          sendData({
            name: `member-register-success`,
            type: 'cart-modal'
          });
        }
      } catch (err) {
        sendData({
          name: `member-register-failed`,
          message: err.message,
          type: 'cart-modal'
        });
      }
    }

    async function recoverAjax(customer_info) {
      const formData = new FormData();
      formData.append("form_type", "recover_customer_password");
      formData.append("utf8", '✓');
      formData.append("email", customer_info.email);
      $('#member-login-modal #login-error').hide()
      $('#member-login-modal .form-error').hide()
      try {
        const recover_res_html = await fetch(`/account/recover`, {
          method: "POST",
          body: formData,
          headers: {
            'cache-control': 'max-age=0'
          }
        }).then((res) => res.text())

        const parser = new DOMParser();
        const doc = parser.parseFromString(recover_res_html, 'text/html');
        const message_dom = doc.querySelector(
          '#recover-success'
        )

        if (message_dom) {
          $('#member-login-modal #login-message').html(message_dom.innerText)
          $('#member-login-modal #login-message').show()
          $('#member-login-modal [href="#login"].t4s-recover-toggle')[0]?.click()
        } else {
          $('#member-login-modal #login-error').html('Too many attempts')
          $('#member-login-modal #login-error').show()
        }
      } catch (err) {
        window.report_faro({
          file_name: 'assets/member-login-register.js',
          func_name: 'recoverAjax',
          desc: 'Failed to recover the member login',
          error: err
        })
      }
    }

    // 处理页面右上角的“个人中心”图标的点击  ------- start ------->
    // mobile 端, 点击 banner
    $(`.account-icon-J, a[href*="rf=site_"]`).on("click", (e) => {
      // 如果用户已经登录，走原来的逻辑
      if (isLogin) return;

      // 未登录，通过 js 来控制
      e.preventDefault();

      const target = e.target;
      const href =
        $(target).closest(".account-icon-J").attr("href") ||
        $(target).closest("[href]").attr("href");
      const queryString = href.split("?")[1];
      const _urlParams = new URLSearchParams(queryString);
      const _rf = _urlParams.get("rf");
      const _utm_source = _urlParams.get("utm_source");

      if (_rf) localStorage.setItem("member-rf", _rf);
      if (_utm_source) localStorage.setItem("member-utm_source", _utm_source);

      // 如果用户未登录：能识别，去登录页；不能识别，去注册页
      const isLogined = localStorage.getItem("member-logined");

      // 带上 rf 或 utm_source 去登录/注册页
      let url = "/account/register";
      if (isLogined) url = "/account/login";
      location.href = url + `?${_urlParams.toString()}`;
    });
    // pc 端
    // 判断用户是否登陆过显示相应的tab
    function initTabByLogined() {
      // 如果用户已经登录，走原来的逻辑
      if (isLogin) return;

      // 如果用户未登录：能识别，去登录页；不能识别，去注册页
      const isLogined = localStorage.getItem("member-logined");
      let _targetTab = "register";
      if (isLogined) _targetTab = "login";

      targetTab = _targetTab;

      // Tab切换功能
      const $tabItems = $(".t4s-tab-item");
      const $tabPanels = $(".t4s-tab-panel");
      // 移除所有 class
      $tabItems.removeClass("active");
      $tabPanels.removeClass("active");
      // 高亮 tab
      document
        .querySelectorAll(`.t4s-tab-item[data-target="${_targetTab}"]`)
        .forEach((element) => {
          element.classList.add("active");
        });
      // 显示 tab 对应的内容
      document.querySelectorAll(`#tab-${_targetTab}`).forEach((element) => {
        element.classList.add("active");
      });
    }

    // 采集 登录/注册 失败的数据  ------- start ------->
    function checkPageFormError() {
      const errorMsg = $(".page-form-error").eq(0).text();
      const errorType = visitType;
      if (errorMsg && errorType) {
        sendData({
          name: `member-${errorType}-failed`,
          message: errorMsg,
        });
      }
    }
    checkPageFormError()
    // 采集 登录/注册 失败的数据  ------- end ------->

    targetTab = visitType;

    // 侧边栏（登录/注册）出现的时候要发送埋点  ---------- start ----------->
    // 目标元素的选择器
    const targetElement = document.getElementById("t4s-login-sidebar");

    if (targetElement) {
      // 创建 MutationObserver 实例
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // 检查是否是 aria-hidden 属性发生变化
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "aria-hidden"
          ) {
            const currentValue = targetElement.getAttribute("aria-hidden");
            if (currentValue === "false")
              sendData({
                name: `member-login-sidebar-show`,
                currentTab: targetTab,
              });
          }
        });
      });

      // 配置观察选项
      const config = {
        attributes: true, // 观察属性变化
        attributeFilter: ["aria-hidden"], // 只观察 aria-hidden 属性
        subtree: false, // 不观察子元素
      };

      // 开始观察目标元素
      observer.observe(targetElement, config);

      // 初始检查（可选）
      const initialValue = targetElement.getAttribute("aria-hidden");
    } else {
      window.report_faro({
        file_name: 'assets/member-login-register.js',
        func_name: 'memberLoginRegisterInit',
        desc: 'Login sidebar element not found',
        error: 'Missing element: #t4s-login-sidebar'
      });
    }
    // 侧边栏（登录/注册）出现的时候要发送埋点  ---------- end ----------->

    const getT = function () {
      return fetch(`${domain}/api/v1/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // 告诉服务器发送的是 JSON
        },
        body: JSON.stringify({
          user_name: "shopify",
          user_password: "MJy7ayjCe6KVv2IESnn9",
        }),
      })
        .then((response) => response.json())
        .catch((error) => {
          window.report_faro({
            file_name: 'assets/member-login-register.js',
            func_name: 'getT',
            desc: 'Failed to fetch the authentication token',
            error: error
          });
        });
    };

    // 推送数据给服务端
    const pushData = function (data, t) {
      fetch(
        `${domain}/api/v1/customer-center/save-shopify-customer-subscription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: t,
          },
          body: JSON.stringify(data),
        }
      )
        .then((response) => response.json())
        .catch((error) => {
          // alert("error:", error);
        });
    };

    // 根据路径自动激活对应标签
    function activateTabBasedOnPath() {
      const marketing_checkbox = document.querySelector('.marketing-checkbox')
      marketing_checkbox.querySelector('.checkbox-ui').classList.add('checked')
      const tabItems = document.querySelectorAll(".t4s-tab-item");
      const tabPanels = document.querySelectorAll(".t4s-tab-panel");

      // 移除所有active类
      tabItems.forEach((tab) => tab.classList.remove("active"));
      tabPanels.forEach((panel) => panel.classList.remove("active"));

      // 找到并激活对应的标签和面板
      const activeTabs = document.querySelectorAll(
        `.t4s-tab-item[data-target="${targetTab}"]`
      );
      if (activeTabs.length) {
        activeTabs.forEach(target => {
          target.classList.add("active");
        })
      } else {
        // alert("activeTab is not exist.");
      }

      const activePanels = document.querySelectorAll(`#tab-${targetTab}`);
      if (activePanels.length) {
        activePanels.forEach(target => {
          target.classList.add("active");
        })
      } else {
        // alert("activePanel is not exist.");
      }
    }

    // 页面加载时激活对应标签
    activateTabBasedOnPath();

    // 忘记密码和回到登录功能
    function switchForgetPwd() {
      const forgotPasswordLinks = document.querySelectorAll(
        ".t4s-recover-toggle"
      );
      forgotPasswordLinks.forEach((link) => {
        link.addEventListener("click", handleRecoverShow);
      });
    }

    // 页面初始化的时候，判断一次
    const hash = window.location.hash;
    if (hash === "#recover") {
      const loginForm = document.getElementById("login");
      const recoverForm = document.getElementById("recover");
      // 前往找回密码页面
      loginForm.style.display = "none";
      recoverForm.style.display = "block";
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 0);

      // 发送重置密码的埋点
      sendData({ name: `member-reset-password` });
      // e.preventDefault();
    }

    // 使用jQuery添加表单校验功能
    function validateInput($input) {
      // 清除之前的错误消息
      const $parentField = $input.closest(".t4s_field");
      $parentField.find(".form-error").remove();
      $input.removeClass("input-error");

      // 检查是否必填
      const requiredMessage = $input.data("requiredMessage");
      if (requiredMessage && $input.val().trim() === "") {
        showError($input, requiredMessage);
        return false;
      }

      // 检查是否符合规则
      const invalidMessage = $input.data("invalidMessage");
      const rulesAttr = $input.data("rules");

      if ($input.val().trim() !== "" && rulesAttr && invalidMessage) {
        try {
          const rules =
            typeof rulesAttr === "string" ? JSON.parse(rulesAttr) : rulesAttr;
          for (let rule of rules) {
            const regex = new RegExp(rule);
            if (!regex.test($input.val().trim())) {
              showError($input, invalidMessage);
              return false;
            }
          }
        } catch (e) {
          // alert("无法解析验证规则:", e);
        }
      }

      return true;
    }

    function showError($input, message) {
      const $parentField = $input.closest(".t4s_field");
      $("<div>")
        .addClass("form-error")
        .text(message)
        .css({
          color: "var(--t4s-error-color)",
          "font-size": "12px",
          "line-height": "12px",
          "margin-top": "5px",
        })
        .appendTo($parentField);

      $input.addClass("input-error");
    }

    // 辅助方法
    function getFormData() {
      try {
        const key = "member-login-or-register-info";
        const formDataStr =
          localStorage.getItem(key) || '{"login": {}, "register": {}}';
        return JSON.parse(formDataStr);
      } catch (e) {
        window.report_faro({
          file_name: 'assets/member-login-register.js',
          func_name: 'getFormData',
          desc: 'Failed to parse saved member form data',
          error: e
        })
        return {};
      }
    }

    function setFormData(data) {
      const key = "member-login-or-register-info";
      localStorage.setItem(key, JSON.stringify(data));
    }

    // 根据 localStorage 中的表单数据初始化表单（回填数据）
    function fillBackData(id) {
      const formDataStorage = getFormData()
      const currentFormDataInLS = formDataStorage[id];
      $(`[id="${id}"]`)
        .find('input[name*="customer"]')
        .not('[type="checkbox"]')
        .each(function (_index, _value) {
          const $item = $(this);
          const name = $item.attr("name");
          const val = currentFormDataInLS[name];

          val && $item.val(val);
        });
    }

    function addEvents() {
      // 点击联登按钮的统计
      document.addEventListener("click", (e) => {
        const target = e.target;
        const loginBtn = target.closest(".h_google_button");
        const fbLoginBtn = target.closest(".h_facebook_button");

        if (loginBtn) {
          sendData({ name: `member-google-login` });
          return;
        }

        if (fbLoginBtn) {
          sendData({ name: `member-facebook-login` });
          return;
        }
      });

      // Tab切换功能
      document.querySelectorAll('.login-or-register .t4s-tab-item').forEach((target) => target.addEventListener('click', function () {
        const $item = $(this);
        const target = $item.attr("data-target");
        const isInSidebar = $("#t4s-login-sidebar").attr("aria-hidden");
        const $parentBox = $item.closest(".login-or-register");
        // 是否是弹窗登陆
        const isLoginModal = $parentBox.attr("id") == 'member-login-modal'

        sendData({ name: `member-click-tab-${target}` });

        // 初始化表单
        fillBackData(target);

        // 记录一下当前 tab
        localStorage.setItem("account-current-tab", target);

        // 在 pc 的 sidebar 中，才用 js 切换，否则，直接跳转页面
        if ((!isMobile && isInSidebar) || isLoginModal) {
          // 移除所有active类
          $parentBox.find(".t4s-tab-item").removeClass("active");
          $parentBox.find(".t4s-tab-panel").removeClass("active");

          // 添加active类到当前tab
          $item.addClass("active");

          // 显示对应内容
          $parentBox.find(`#tab-${target}`).addClass("active");
        } else {
          // 如果要跳转的页面和当前页相同，不做任何操作
          if (target === targetTab) return;
          location.href = `/account/${target}`;
        }
      }));

      $('a[href="/account"][data-drawer-options]').on("click", initTabByLogined);

      // 使用jQuery事件委托监听所有表单的input blur事件
      $(".login-or-register")
        .find("form")
        .each(async function () {
          const $form = $(this);

          // 为所有input添加blur事件
          $form.on(
            "blur",
            'input:not([type="hidden"]):not([type="submit"]):not([type="checkbox"])',
            function () {
              validateInput($(this));
            }
          );

          const login_box = $form.closest("#member-login-modal")
          const is_member_modal = login_box.length > 0

          // 表单提交验证
          $form.find(".j-submitBtn").on("click", async function (e) {
            // e.preventDefault();
            try {
              const submit_btn = $(e.target)
              let isValid = true;
              const _first_name = $form.find('[name="customer\\[first_name\\]"]').val();
              const _last_name = $form.find('[name="customer\\[last_name\\]"]').val();
              const _email = $form.find('[name="customer\\[email\\]"]').val();
              const _recover_email = $form.find('#RecoverEmail').val();
              const _password = $form.find('[name="customer\\[password\\]"]').val();
              const _marketing = $form.find('[name="customer\\[accepts_marketing\\]"]').val();
              const $inputs = $form.find(
                'input:not([type="hidden"]):not([type="submit"]):not([type="checkbox"])'
              );

              $inputs.each(function () {
                if (!validateInput($(this))) {
                  isValid = false;
                }
              });

              const current_tab = $form.attr('id')?.split('_')[1]
              // 点击“提交”按钮，上报点击
              sendData({
                name: `member-form-submit__${current_tab}`,
                email: _email || "",
                type: is_member_modal ? 'cart-modal' : ''
              });

              // 验证隐私条款是否勾选
              // if (!validatePrivacyPolicy($form)) {
              //   isValid = false;
              // }

              if (!isValid) {
                e.preventDefault();
                // 滚动到第一个错误输入
                const $firstError = $form
                  .find(".input-error, .form-error")
                  .first();
                if ($firstError.length) {
                  $("body").animate(
                    {
                      scrollTop: $firstError.offset().top - 100,
                    },
                    300
                  );
                  // 如果错误元素是输入框，则聚焦
                  if ($firstError.is("input")) {
                    $firstError.focus();
                  }
                }

                // 上报：表单校验失败
                sendData({
                  name: `member-form-submit-invalid-info__${targetTab}`,
                });
                // 校验失败短路return
                return;
              }

              // 检验成功后的逻辑-------------------------------------------------

              submit_btn.addClass('is--loading')

              // 表单验证成功，如果用户勾选了订阅，保存订阅信息
              if (
                _marketing === "true" &&
                _email
              ) {
                getT().then(function (res) {
                  const tInfo = res || {};
                  const t = (tInfo.data || {}).token;

                  pushData(
                    {
                      email: _email,
                      status:
                        $('[name="customer\\[accepts_marketing\\]"]').val() ===
                          "true"
                          ? 1
                          : 2,
                    },
                    t
                  );
                });
              }
              // 仅是弹窗登陆下才走AJAX
              const current_form = $form.attr('id')
              if (is_member_modal) {
                switch (current_form) {
                  case 'cusomter_recover':
                    e.preventDefault();
                    await recoverAjax({
                      email: _recover_email
                    });
                    break;
                  case 'customer_login':
                    e.preventDefault();
                    await loginAjax({
                      email: _email,
                      password: _password
                    })
                    break
                  case 'cusomter_register':
                    e.preventDefault();
                    await registerAjax({
                      email: _email,
                      password: _password,
                      first_name: _first_name,
                      last_name: _last_name,
                      marketing: _marketing
                    })
                    break
                }

              }
              submit_btn.removeClass('is--loading')

            } catch (e) {
              // alert(">>>>> pushData error:", e);
            }
          });
        });

      // 保存登录/注册表单的值
      $("#login")
        .find('input[name*="customer"]')
        .not('[type="checkbox"]')
        .not('[type="password"]')
        .add(
          $("#register")
            .find('input[name*="customer"]')
            .not('[type="checkbox"]')
            .not('[type="password"]')
        )
        .on("input", function (e) {
          const $formItem = $(this);
          const $form = $formItem.parents("form");
          const formItemName = $formItem.attr("name");
          const id = $form.parent().attr("id");
          const formData = getFormData();
          const val = e.target.value;

          if ($formItem.attr("type") === "password") return;

          if (formData && id && formItemName && formData[id])
            formData[id][formItemName] = val;

          setFormData(formData);
        });

      // 显示/隐藏密码
      $(document).on("click", ".hide-or-show-password", function () {
        const $box = $(this);
        $box
          .prev("input")
          .attr("type", $box.hasClass("show") ? "text" : "password");
        $box.toggleClass("show");
      });
      // 绑定忘记密码事件
      switchForgetPwd()
    }

    //事件绑定
    addEvents()

    // 回填表单数据
    fillBackData(targetTab);

    // });
  } catch (e) {
    window.report_faro({
      file_name: 'assets/member-login-register.js',
      func_name: 'memberLoginRegisterInit',
      desc: 'Member login and registration initialization failed',
      error: e
    });
  }
}

document.addEventListener('login-sidebar-inited', memberLoginRegisterInit)
